import React from 'react';
import _ from 'lodash';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import StatusBox from 'components/StatusBox';
import ExternalLink from 'components/ExternalLink';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import {GOCARDLESS_PAYMENT_STATUSES} from 'ducks/tenancy';

import launchLinkIcon from './assets/launch-47.svg';

import './styles.css';

const GocardlessCustomerPaymentRow = ({
  payment,
  openInvoiceDetailModal,
  openGocardlessPaymentDetailModal
}) => (
  <Table.Row
    className="GocardlessCustomerPaymentRow"
    onClick={() =>
      openGocardlessPaymentDetailModal(payment.invoice.scheduleType, payment.id)
    }>
    <Table.Cell className="created">{formatDate(payment.createdAt)}</Table.Cell>
    <Table.Cell className="charged">
      {payment.chargeDate && formatDate(payment.chargeDate)}
      {!payment.chargeDate && '-'}
    </Table.Cell>
    <Table.Cell className="amount">{payment.amount}</Table.Cell>
    <Table.Cell className="gc">{payment.gocardlessId}</Table.Cell>
    <Table.Cell>
      <ExternalLink className="gcLink" href={payment.link} targetBlank>
        <img src={launchLinkIcon} alt="Open GoCardless Payment" />
      </ExternalLink>
    </Table.Cell>
    <Table.Cell className="status">
      <StatusBox
        color={GOCARDLESS_PAYMENT_STATUSES[payment.status.value].color}
        status={payment.status.verbose}
      />
    </Table.Cell>
    <Table.Cell className="colabInvoice">
      <ClickIconWithNoPropagation
        onClick={() =>
          openInvoiceDetailModal(
            payment.invoice.scheduleType,
            payment.invoice.id
          )
        }>
        <p className="colab-bold">{payment.invoice.idString}</p>
      </ClickIconWithNoPropagation>
    </Table.Cell>
  </Table.Row>
);

const PaymentsHistory = ({
  gocardlessCustomerPayments,
  openInvoiceDetailModal,
  openGocardlessPaymentDetailModal
}) => (
  <div className="PaymentsHistory">
    <div className="horizontalLine" />
    <h5 className="header">History</h5>
    {!_.isEmpty(gocardlessCustomerPayments) && (
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Created" className="created" />
          <Table.HeaderItem heading="Charged" className="charged" />
          <Table.HeaderItem heading="Amount" className="amount" />
          <Table.HeaderItem heading="GC" className="gc" />
          <Table.HeaderItem heading="GC Link" className="gcLink" />
          <Table.HeaderItem heading="Status" className="status" />
          <Table.HeaderItem heading="Colab Invoice" className="colabInvoice" />
        </Table.Header>
        <Table.Body>
          {gocardlessCustomerPayments.map(payment => (
            <GocardlessCustomerPaymentRow
              key={payment.id}
              payment={payment}
              openInvoiceDetailModal={openInvoiceDetailModal}
              openGocardlessPaymentDetailModal={
                openGocardlessPaymentDetailModal
              }
            />
          ))}
        </Table.Body>
      </Table>
    )}
  </div>
);

export default PaymentsHistory;
